// extracted by mini-css-extract-plugin
export default {"loading-spinner":"LoadingSpinner_loading-spinner__jsw-W","spinner":"LoadingSpinner_spinner__sKrI+"};